<template>
  <v-card class="pa-3" style="cursor: default;">
    <div class="">
      <div class="d-flex justify-space-between align-center">
        <div class="flex-column align-center">
          <div class="d-flex align-center">
            <table-action-button
              v-if="subItems && showOrder"
              :icon="showSubItems ? 'arrow_upward' : 'arrow_downward'"
              :text="showSubItems ? 'Fechar pares contidos' : 'Abrir pares contidos'"
              @click="showSubItems = !showSubItems"
            />
            <div class="flex-column ml-2">
              <div v-if="showOrder" class="subtitle-1">
                <span class="font-weight-bold"> Ordem: </span>
                {{ Number(order) + 1 || order }}
              </div>
              <div>
                <span class="font-weight-bold"> Nome: </span> {{ name }}
              </div>
              <div v-if="subItems && showOrder">
                <span class="font-weight-bold"> Pares: </span> {{ totalSubItems }}
              </div>
            </div>
          </div>
        </div>
        <div>
          <v-chip
            v-if="!showOrder && subItems"
            style="margin-right: 10px;"
            label
            outlined
            pill
          >
            {{ subItems }}
          </v-chip>
          <table-action-button
            :icon="iconButton"
            :text="tooltipButton"
            @click="$emit('click')"
          />
        </div>
      </div>

      <!-- Subitens habilitados (ordenáveis) -->
      <draggable
        v-if="showSubItems && enabledSubItems.length"
        :list="newSelectedSubItems"
        handle=".drag-handle"
        :animation="200"
        class="mt-3"
        @end="updateOrderAfterDrag"
      >
        <v-card
          v-for="(par, idx) in newSelectedSubItems"
          :key="par.id || idx"
          class="mb-2 pa-2 d-flex justify-space-between align-center"
          outlined
        >
          <div class="d-flex align-center">
            <v-icon
              size="20"
              class="mr-2 drag-handle"
              style="cursor: grab;"
            >drag_indicator</v-icon>
            <span class="font-weight-bold">Par:</span>
            {{ par.name || par.description }}
          </div>
          <v-switch
            style="margin-top:-3px"
            :input-value="isSelected(par)"
            @change="toggleSubItem(par)"
            hide-details
            dense
          />
        </v-card>
      </draggable>

      <!-- Subitens desabilitados (não ordenáveis, ordem original) -->
      <div v-if="showSubItems && disabledSubItems.length">
        <v-card
          v-for="(par, idx) in disabledSubItems"
          :key="par.id || idx"
          class="mb-2 pa-2 d-flex justify-space-between align-center"
          outlined
        >
          <div class="d-flex align-center">
            <span class="font-weight-bold ml-6">Par:&nbsp;</span>
            {{ par.name || par.description }}
          </div>
          <v-switch
            style="margin-top:-3px"
            :input-value="isSelected(par)"
            @change="toggleSubItem(par)"
            hide-details
            dense
          />
        </v-card>
      </div>
    </div>
  </v-card>
</template>

<script>
import draggable from "vuedraggable";

export default {
  components: { draggable },
  data: () => ({
    showSubItems: false,
  }),
  props: {
    type: {
      type: String,
      required: false,
    },
    item: {
      type: Object,
      required: true,
    },
    order: {
      type: [Number, String],
      required: false,
    },
    iconButton: {
      type: String,
      required: () => this.showButton,
    },
    tooltipButton: {
      type: String,
      required: () => this.showButton,
    },
    showOrder: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    subItems() {
      const size = this.item?.aggregation?.pares?.length || null;
      return size ? size > 1 ? `${size} pares` : `${size} par` : null;
    },

    newSelectedSubItems() {
      return this.item?.sequenceAggregationPairOrder?.map(item => {
        return this.item.aggregation.pares.find(p => p.id === item.parId);
      }).filter(Boolean) || [];
    },

    totalSubItems() {
      const selected = this.item?.sequenceAggregationPairOrder?.length || 0;
      const total = this.item?.aggregation?.pares?.length || 0;
      return `${selected}/${total}`;
    },

    name() {
      const item = this.item;

      const entity = item.trackingPoint
        || item.tumoralPhenomenon
        || item.vascularPhenomenon
        || item.potentialSpace
        || item.flowType
        || item.oligoelement
        || item.chakra
        || item.chromosome
        || item.complementarTherapy
        || item.par
        || item.aggregation;

      return entity?.name || entity?.description;
    },

    enabledSubItems() {
      if (!this.item.aggregation || !this.item.aggregation.pares) return [];
      return this.item.sequenceAggregationPairOrder || [];
    },

    disabledSubItems() {
      if (!this.item.aggregation || !this.item.aggregation.pares) return [];
      return this.item.aggregation.pares.filter(
        par => !this.item?.sequenceAggregationPairOrder.some(sel => sel.parId === par.id)
      );
    },
  },
  methods: {
    isSelected(par) {
      return this.item.sequenceAggregationPairOrder.some(item => item.parId === par.id);
    },
    toggleSubItem(par) {
      const idx = this.item.sequenceAggregationPairOrder.findIndex(item => item.parId === par.id);
      let removedItens = [];
      if (idx === -1) {
        this.item.sequenceAggregationPairOrder.push({
          id: null,
          order: this.item.sequenceAggregationPairOrder.length,
          parId: par.id,
          par,
          sequenceAggregationOrder: this.item.id,
        });
      } else {
        removedItens = [ this.item.sequenceAggregationPairOrder[idx] ];
        this.item.sequenceAggregationPairOrder.splice(idx, 1);
      }

      this.$emit(
        'updateSubItems',
        this.item.id,
        this.item.sequenceAggregationPairOrder,
        removedItens
      );
    },
    updateOrderAfterDrag() {
      // Reorganiza o item.sequenceAggregationPairOrder baseado na nova ordem de newSelectedSubItems
      const updatedOrder = this.newSelectedSubItems.map((par, idx) => {
        // Encontra o item original correspondente ao par
        const originalItem = this.item.sequenceAggregationPairOrder.find(
          item => item.parId === par.id
        );
        
        // Retorna um novo objeto com a ordem atualizada
        return {
          ...originalItem,
          order: idx
        };
      });

      // Substitui o array original com o novo array ordenado
      this.item.sequenceAggregationPairOrder = [...updatedOrder];
      
      // Emite evento para atualizar no componente pai
      this.$emit(
        'updateSubItems',
        this.item.id,
        this.item.sequenceAggregationPairOrder,
        []
      );
    },
  }
};
</script>
<style></style>